module.exports = __webpack_public_path__ + "img/google.5eb55ff2.png";